import script from "./ManualTripReviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualTripReviewModal.vue?vue&type=script&setup=true&lang=js"

import "./ManualTripReviewModal.vue?vue&type=style&index=0&id=48fbaac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48fbaac2"]])

export default __exports__